<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">Imágenes</b-card-header>
      <b-card-body>
        <div class="row form-group">
          <div class="col-md-12">
            <base-button type="success" @click="muestraModal = true;">Agregar imagen</base-button>
          </div>
        </div>
        <div class="row form-group">
          <div
            v-for="item in imagenes"
            @click="itemClicked(item)"
            v-bind:key="item.ImageID"
            :value="item.ImageID"
            class="col-md-3 text-center"
          >
            <div
              class="container"
              style="position: relative;  text-align: center;  color: white; width: 150px"
            >
              <img
                :src="item.Image"
                class="rounded-circle"
                style="width: 150px; cursor: pointer"
                alt
              />
              <i
                v-if="item.Current"
                class="fa fa-fw fa-check-circle"
                style="color: green;    font-size: 30px; position: absolute;  bottom: 8px;  right: -20px;"
              ></i>
            </div>
          </div>
        </div>
      </b-card-body>
    </b-card>

    <modal :show.sync="muestraModal">
      <template slot="header">
        <h5 class="modal-title" id="exampleModalLabel">Agregar imagen</h5>
      </template>
      <div>
        <div class="row">
          <div class="col-md-12 text-center">
            <image-uploader
              :preview="true"
              :className="['fileinput', { 'fileinput--loaded': hasImage }]"
              capture="environment"
              :maxHeight="400"
              outputFormat="verbose"
              @input="setImage"
            >
              <label for="fileInput" slot="upload-label" style="cursor:pointer">
                <figure>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                  >
                    <path
                      class="path1"
                      d="M9.5 19c0 3.59 2.91 6.5 6.5 6.5s6.5-2.91 6.5-6.5-2.91-6.5-6.5-6.5-6.5 2.91-6.5 6.5zM30 8h-7c-0.5-2-1-4-3-4h-8c-2 0-2.5 2-3 4h-7c-1.1 0-2 0.9-2 2v18c0 1.1 0.9 2 2 2h28c1.1 0 2-0.9 2-2v-18c0-1.1-0.9-2-2-2zM16 27.875c-4.902 0-8.875-3.973-8.875-8.875s3.973-8.875 8.875-8.875c4.902 0 8.875 3.973 8.875 8.875s-3.973 8.875-8.875 8.875zM30 14h-4v-2h4v2z"
                    />
                  </svg>
                </figure>
                <span class="upload-caption">
                  {{
                  hasImage ? "Cambiar" : "Subir"
                  }}
                </span>
              </label>
            </image-uploader>
          </div>
        </div>
        <div class="row" v-if="image != null">
          <div class="col-md-12">
            <cropper
              class="cropper"
              :src="image.dataUrl"
              :stencil-props="{
		aspectRatio: 12/12
	}"
              @change="change"
              :stencilComponent="$options.components.CircleStencil"
            ></cropper>
          </div>
        </div>
      </div>
      <template slot="footer">
        <base-button type="primary" @click="subirImagen">Confirmar</base-button>
        <base-button type="secondary" @click="muestraModal = false">Cerrar</base-button>
      </template>
    </modal>
  </div>
</template>

<style>
#fileInput {
  display: none;
}

.img-preview {
  display: none;
}
</style>


<script>
// ******************** Select ********************//
import Vue from "vue";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
// ******************** Select ********************//

import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";

import KitsCombo from "@/components/KitsCombo";
import KitsBusquedaSimple from "@/components/KitsBusquedaSimple";
import confirmHelpers from "@/helpers/confirmHelpers";

import ImageUploader from "vue-image-upload-resize";
Vue.use(ImageUploader);
import { Cropper, CircleStencil } from "vue-advanced-cropper";

export default {
  components: { KitsCombo, KitsBusquedaSimple, Cropper, CircleStencil },
  data() {
    return {
      imagenes: [],
      muestraModal: false,
      hasImage: false,
      image: null,
      resultImage: null
    };
  },
  methods: {
    change({ coordinates, canvas }) {
      console.log(coordinates, canvas);
      this.resultImage = canvas.toDataURL();
    },
    setImage: function(output) {
      this.hasImage = true;
      this.image = output;
      console.log(this.image);
    },
    subirImagen() {
        if(this.resultImage == null){
            notificationHelpers.showWarning('Advertencia!', 'Debe cargar una imagen', this);
            return;
        }

        let context = this;
        let req = { FileStream: this.resultImage.replace('data:image/png;base64,', ''), Extension: 'png', CroppedImage: true, ImageTypeID: 1 };

        axiosHelpers.axiosPost(
            "Account/AddImage",
            req,
            context,
            function(data) {
              if (data.ResponseVM.Resultado) {
                notificationHelpers.showSuccess(
                  "Exito",
                  "Se agregó la imagen correctamente",
                  context
                );
                context.cargarImagenes();
                context.resultImage = null;
                context.image = null;
                context.muestraModal = false;
                context.$router.go(-1)
              }
            }
          );

    },
    itemClicked(item) {
      let context = this;
      confirmHelpers.showConfirm(
        "Está seguro que desea establecer la imagen como la actual?",
        this,
        function() {
          axiosHelpers.axiosPost(
            "Account/SetCurrentImage",
            { ImageID: item.ImageID },
            context,
            function(data) {
              if (data.ResponseVM.Resultado) {
                notificationHelpers.showSuccess(
                  "Exito",
                  "Se cambió la imagen correctamente",
                  context
                );
                                context.$router.go(-1)
              }
            }
          );
        }
      );
    },
    cargarImagenes() {
      let context = this;

      axiosHelpers.axiosGet("Account/ImageManagement", {}, this, function(
        data
      ) {
        context.imagenes = data.ResponseVM;
      });
    }
  },
  beforeMount: function() {
    this.cargarImagenes();
  }
};
</script>